import { Navigate } from 'react-router-dom';
import { useMasterAuth } from '@/contexts/MasterAuthContext';

export default function MasterRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useMasterAuth();
  if (!isAuthenticated) return <Navigate to="/master/login" replace />;
  return <>{children}</>;
}
